import { CreateElement, VNode } from "vue";
import { Vue, Component, Model, Prop } from "vue-property-decorator";
import { busy, db, VIPCompany, VIPContact } from "@/loader";

@Component
export default class ContactSelect extends Vue {
	@Model("input", { default: null })
	public value!: any;

	@Prop({ type: Boolean, default: false })
	public multiple!: boolean;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	@Prop({ type: Array, default: () => [] })
	public include!: VIPContact[];

	@Prop({ type: Array, default: () => [] })
	public exclude!: VIPContact[];

	@Prop({ type: Function, default: (option: VIPContact) => option.id })
	public reduce!: Function;

	@Prop({ type: VIPCompany, default: null })
	public company!: VIPCompany | null;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get contacts(): VIPContact[] {
		return (this.company ? this.company.contacts : db.contacts.list)
			.filter(c => (!this.include.length || this.include.includes(c)) && !this.exclude.includes(c))
			.sort((a, b) => a.toStringNoCiv().localeCompare(b.toStringNoCiv()));
	}

	public filter(options: VIPContact[], search: string) {
		search = search.toLowerCase().removeDiacritics();
		return options.filter(option => option.toStringNoCiv().toLowerCase().removeDiacritics().includes(search));
	}

	public render(h: CreateElement): VNode {
		let select = h("v-select", {
			class: "form-control",
			attrs: {
				name: "contact",
			},
			props: {
				label: "last_name",
				value: this.value,
				disabled: this.isBusy,
				readonly: !this.canEdit,
				options: this.contacts,
				reduce: this.reduce,
				filter: this.filter,
			},
			on: {
				input: (value: any) => this.$emit("input", value),
			},
			scopedSlots: {
				option: (option: VIPContact) => option.toString(),
				"selected-option": (option: VIPContact) => option.toString(),
			},
		});

		return select;
	}
}
